/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes, { func } from 'prop-types';
import InputMask from 'react-input-mask';
import moment from 'moment';
import {
  Form,
  Input,
  Select,
  Radio,
  InputNumber,
  Upload,
  Col,
  Popconfirm,
  Row,
  DatePicker,
  Spin,
  Card,
  Button,
  notification,
  Anchor,
} from 'antd';
import {
  InboxOutlined,
  DownloadOutlined,
  DeleteOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import ProjectInfoPerson from './ProjectInfoPerson';
import './ProjectInfo.css';
import organisations from '../../organisations';
import { numberToWords } from '../../../../utils/numberToWords';
import {
  getAgreementData,
  updateAgreementData,
  editApplications2,
  editApplications2PersonsTabPeople,
  getApplications2ById,
  uploadFile,
  updateCoexecutorProject,
} from '../../../../utils/http';
import getUserRole from '../../../../utils/localeStorage/getUserRole';
import { approveValidationAgreement } from '../../../../utils/approveValidationAgreement';
import PlanRow from './PlanRow';
import { useHistory } from 'react-router-dom'
import { DocumentsList } from '../Documents/Documents';

const { TextArea } = Input;
const { Option } = Select;
const { Dragger } = Upload;

const calcTotalByKeys = (el, keys) => {
  let sum = 0;

  keys.forEach((key) => {
    sum +=
      parseFloat(
        `${el[`${key}Major`] || 0}.${`${el[`${key}Minor`]}`.length === 1
          ? `0${el[`${key}Minor`]}`
          : el[`${key}Minor`]
        }`
      ) * 100;
  });

  const major =
    Math.trunc(sum / 100) === 0 && sum < 0
      ? `-0${Math.trunc(sum / 100)}`
      : Math.trunc(sum / 100);
  const minor = Number((sum % 100).toFixed(0));

  if (major === 0) {
    return '';
  }

  return { major, minor };
};

function parseDate(date, fallbackDate) {
  const dateString = date?.replace('года', '');
  return date
    ? moment(dateString, 'DD MMMM YYYY')
    : moment(fallbackDate, 'DD MMMM YYYY');
}

const getWordedNumber = (major) => {
  const summ = `${numberToWords(major)}`;
  const firstLetter = summ.charAt(0);
  const firstLetterCap = firstLetter.toUpperCase();
  const remainingLetters = summ.slice(1);

  return `${firstLetterCap}${remainingLetters}`;
};

function ProjectInfo({ applicationProp, onRedirectToList }) {
  const [agreementData, setAgreementData] = useState();
  const [application, setApplication] = useState(applicationProp);
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const [documentFile, setDocumentFile] = useState(agreementData?.documentFile);
  // const [requisitesType, setRequisitesType] = useState(agreementData?.requizit_type || 'commercial');

  const history = useHistory();

  const disabled = true;

  const fetchAgreementData = async () => {
    const { id } = application;
    const resp = await getAgreementData();

    const data = resp.payload.find(
      (agreement) => agreement.application.id === id
    );
    if (data) {
      setAgreementData(data);
    }
  };

  useEffect(() => {
    setLoading(true);

    fetchAgreementData().then(() => {
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    setDocumentFile(agreementData?.documentFile);
    // if (agreementData?.requizit_type) {
    //   setRequisitesType(agreementData?.requizit_type);
    // }
  }, [agreementData]);

  const hospitalTotal = calcTotalByKeys(application, [
    'fotTotal',
    'equipmentTotal',
    'materialTotal',
    'otherTotal',
    'paperTotal',
  ]);

  const getStepSum = (year) => {
    const financeTotal = `${application[`financeTotal${year}Major`]}.${application[`financeTotal${year}Minor`]?.toString().length === 1
        ? `0${application[`financeTotal${year}Minor`]}`
        : application[`financeTotal${year}Minor`]
      }`;
    const peopleTotal = `${application[`people${year}Major`]}.${application[`people${year}Minor`]?.toString().length === 1
        ? `0${application[`people${year}Minor`]}`
        : application[`people${year}Minor`]
      }`;

    const diff = parseFloat(financeTotal) - parseFloat(peopleTotal);

    const diffArr = diff.toFixed(2).split('.');
    return {
      major: diffArr[0] || 0,
      minor: diffArr[1] || 0,
    };
  };

  const saveData = async () => {
    const values = formRef.current.getFieldsValue();

    values.money_sum_minor = hospitalTotal.minor || 0;
    values.money_sum_major = hospitalTotal.major || 0;

    values.step1SumMajor = getStepSum('2023').major;
    values.step1SumMinor = getStepSum('2023').minor;

    if (
      application.projectTerm === '2' ||
      applicationProp.projectTerm === '3'
    ) {
      values.step2SumMajor = getStepSum('2024').major;
      values.step2SumMinor = getStepSum('2024').minor;
    }

    if (application.projectTerm === '3') {
      values.step3SumMajor = getStepSum('2025').major;
      values.step3SumMinor = getStepSum('2025').minor;
    }

    if (!values.etap2_documents) {
      values.etap2_documents = JSON.stringify([{}]);
    }

    if (!values.etap3_documents) {
      values.etap3_documents = JSON.stringify([{}]);
    }

    if (values.meri_podderjki?.length) {
      try {
        const promises = values.meri_podderjki?.map((el) =>
          editApplications2PersonsTabPeople({
            id: el.id,
            meri_podderjki: el,
          })
        );
        await Promise.all(promises);
      } catch (error) {
        // notification.error({
        //   message: 'Произошла ошибка при сохранении данных',
        // });
      }
    }

    delete values.meri_podderjki;

    //   if (requisitesType === 'commercial') {
    //     values.kaznachestvo = '';
    //     values.kaznachestvo_schet = '';
    //     values.kaznachestvo_schet_number = '';
    //     values.bik_tofk = '';
    //   } else if (requisitesType === 'government') {
    //     values.rs = '';
    //     values.ks = '';
    //     values.bik = '';
    // }

    Object.entries(values).forEach(([key, value]) => {
      if (key === '') {
        delete values[key];
      }

      if (key.includes('date')) {
        values[key] = value.format('DD MMMM YYYY года');
      }
    });

    await updateAgreementData({
      ...values,
      id: agreementData?.id || undefined,
      application: application.id,
    });
  };

  const onSaveForm = async () => {
    setLoading(true);
    await saveData();
    await fetchAgreementData();
    const newApplicationData = await getApplications2ById(application.id);
    setApplication(newApplicationData);
    setLoading(false);
  };

  const handlePepChange = () => {
    const fields = formRef.current.getFieldsValue();

    formRef.current.setFieldsValue({
      ...fields,
      ppep_3: parseInt(fields.ppep_3_1, 10) + application?.numberOfPerformance,
    });
  };

  const generateAgreement = async () => {
    const values = formRef.current.getFieldsValue();

    const { isError, tabs } = approveValidationAgreement(values, application);

    if (isError) {
      notification.error({
        message:
          'Ошибка завершения заполнения. Заполните обязательные поля и исправьте ошибки!',
        style: { width: 1000 },
        duration: 100,
        description: (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              overflowY: 'scroll',
              height: '80vh',
            }}
          >
            {tabs.map((tab) => {
              if (tab.errorFields.length > 0) {
                return (
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                      {tab.label}
                    </div>
                    <ul>
                      {tab.errorFields.map((f) => (
                        <li key={f}>{f}</li>
                      ))}
                    </ul>
                  </div>
                );
              }
              return null;
            })}
          </div>
        ),
      });
      setLoading(false);
      return false;
    }

    setLoading(true);
    await saveData();

    const req = await updateAgreementData({
      id: agreementData?.id || undefined,
      application: application.id,
      generate: true,
    });

    if (req.file) {
      window.open(req.file, '_blank');
    } else {
      notification.error({
        message: 'Произошла ошибка при генерации документа. Попробуйте еще раз',
      });
    }

    setLoading(false);

    return true;
  };

  const handleCancelProject = async () => {
    setLoading(true);
    editApplications2({
      id: application.id,
      status: 'Предварительно оценена',
    }).then(() => onRedirectToList());
  };

  const onUploadFile = async (file) => {
    if (file.file.status === 'uploading' && !file.event) {
      const form = new FormData();
      const headers = {
        'Content-Type': 'multipart/form-data',
      };
      form.append('documentFile', file.file.originFileObj);
      form.append('id', agreementData.id);
      form.append('application', application.id);
      setDocumentFile(file.file.originFileObj);
      await updateAgreementData(form, headers);
    }
  };

  const onDeleteFile = async () => {
    try {
      await updateAgreementData({
        id: agreementData.id,
        application: application.id,
        documentFile: null,
      });
    } catch (e) {
      notification.error({
        message: 'Произошла ошибка. Попробуйте еще раз',
      });
    }

    setDocumentFile(null);
  };

  const handleCreateCoexecutorProject = async (id, type) => {
    const displayID = () => {
      const coexecutorsCount = application.coexecutors_id.filter((el) => {
        if (type === 'nir') {
          return el.isNIR;
        } else if (type === 's') {
          return el.isS;
        }
      }).length

      if (type === 'nir') {
        return `${application.displayID}/25-${coexecutorsCount + 1}НИР`;
      } else if (type === 's') {
        return `${application.displayID}/25-${coexecutorsCount + 1}С`;
      }
    }

    const obj = {
      application2_id: application.id,
      coexecutorsPersonId: id,
      display_id: displayID(),
      agreement_id: agreementData.id,
      // user: userID,
      isNIR: type === 'nir',
      isS: type === 's',
    };

    setLoading(true)

    try {
      const result = await updateCoexecutorProject(obj);

      if (result[0].id) {
        history.push(`/application2/coexecutors/${result[0].id}`,);
      }

      await fetchAgreementData()
      setLoading(false);
      notification.success({
        message: 'Проект соисполнителя успешно создан',
      });
    } catch {
      setLoading(false)
      notification.error({
        message: 'Произошла ошибка. Попробуйте еще раз',
      });
    }
  };

  console.log(application)

  return (
    <Form ref={formRef} className="project-info">
      {loading ? (
        <Spin
          indicator={
            <LoadingOutlined style={{ fontSize: 100, zIndex: 100 }} spin />
          }
          style={{ position: 'absolute', top: '40%', left: '40%' }}
        />
      ) : (
        <Row gutter={24}>
          <Col span={16}>

            <Card
              style={{
                width: '100%',
                borderRadius: '15px',
                marginTop: '20px',
                height: '100%',
              }}
            >
              <div className="shortTab-wrapper">
                <Form.Item
                  name="application"
                  initialValue={application.id}
                  hidden
                />
                <Form.Item name="id" initialValue={agreementData?.id} hidden />

                <div className="common-subTitle" style={{ fontSize: '20px' }}>
                  <b>
                    Краткие сведения о Грантополучателе для генерации Соглашения
                    на предоставление гранта
                  </b>
                </div>

                <div
                  className="common-table-wrapper"
                  style={{ marginBottom: '0' }}
                >
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderBottom: '1px solid #d9d9d9' }}
                    >
                      Полное наименование организации (в{' '}
                      <b>именительном падеже</b>
                      );
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="fullOrgNameMain"
                      initialValue={
                        agreementData?.fullOrgNameMain ||
                        application.organisationFullName
                      }
                    >
                      <TextArea autoSize />
                    </Form.Item>
                  </div>

                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderBottom: '1px solid #d9d9d9' }}
                    >
                      Полное наименование организации (в{' '}
                      <b>родительном падеже</b>
                      );
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="fullOrgNameRod"
                      initialValue={
                        agreementData?.fullOrgNameRod ||
                        application.organisationFullName
                      }
                    >
                      <TextArea autoSize />
                    </Form.Item>
                  </div>

                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderBottom: '1px solid #d9d9d9' }}
                    >
                      Полное наименование организации (в <b>предложном падеже</b>
                      );
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="fullOrgName"
                      initialValue={
                        agreementData?.fullOrgName ||
                        application.fullOrgNameMain ||
                        application.organisationFullName
                      }
                    >
                      <TextArea autoSize />
                    </Form.Item>
                  </div>
                </div>

                <div className="common-table-wrapper">
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{
                        borderRight: '1px solid #d9d9d9',
                        borderBottom: '1px solid #d9d9d9',
                      }}
                    >
                      Должность лица, уполномоченного на право подписи, в{' '}
                      <b>именительном падеже</b> (указывается с заглавной буквы)
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="directorPositionNew"
                      initialValue={
                        agreementData?.directorPositionNew ||
                        application.directorPosition?.toLowerCase()
                      }
                    >
                      <TextArea autoSize />
                    </Form.Item>
                  </div>
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{
                        borderRight: '1px solid #d9d9d9',
                        borderBottom: '1px solid #d9d9d9',
                      }}
                    >
                      Должность лица, уполномоченного на право подписи, в{' '}
                      <b>родительном падеже</b> (указывается со строчной буквы)
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="dolznost_rod"
                      initialValue={
                        agreementData?.dolznost_rod ||
                        application.directorPosition?.toLowerCase()
                      }
                    >
                      <TextArea autoSize />
                    </Form.Item>
                  </div>
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{
                        borderRight: '1px solid #d9d9d9',
                        borderBottom: '1px solid #d9d9d9',
                      }}
                    >
                      ФИО лица, уполномоченного на право подписи, в{' '}
                      <b>родительном падеже</b>
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="fio_rod"
                      initialValue={
                        agreementData?.fio_rod || application.directorFullName
                      }
                    >
                      <TextArea autoSize />
                    </Form.Item>
                  </div>

                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderBottom: '1px solid #d9d9d9' }}
                    >
                      Документ на право подписи уполномоченного лица со стороны
                      Грантополучателя (указывается с большой буквы) (в{' '}
                      <b>родительном падеже</b>)
                      <div
                        style={{
                          marginTop: '16px',
                          fontStyle: 'italic',
                          fontSize: 12,
                        }}
                      >
                        Если соглашение подписывает уполномоченное лицо, в этом
                        поле следует указать тип и реквизиты документа, на
                        основании которого данное лицо имеет право подписывать
                        данное Соглашение.
                        <br></br>
                        <br></br>
                        Например: Доверенности № 23/15-6 от «02» февраля 2025 года
                      </div>
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="osnovanie"
                      initialValue={agreementData?.osnovanie || 'Устава'}
                    >
                      <TextArea autoSize />
                    </Form.Item>
                  </div>

                  <div className="application-main-box-content-wrapper">
                    <Dragger
                      showUploadList={false}
                      onChange={onUploadFile}
                      disabled={loading}
                      multiple
                      action={null}
                    >
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p
                        className="ant-upload-text"
                        style={{
                          fontStyle: 'normal',
                          fontWeight: 700,
                          fontSize: 18,
                        }}
                      >
                        Файл документа, подтверждающий право подписи
                        уполномоченного лица, необходимо прикрепить, если
                        используется любой документ, кроме Устава.
                      </p>
                      <p className="ant-upload-text">
                        Выберите или перенесите файл, чтобы загрузить (не более
                        15мб). Для прикрепления нескольких файлов осуществляйте их
                        загрузку по очереди, а не одновременно
                      </p>
                    </Dragger>
                    {documentFile && (
                      <Row style={{ margin: '5px 0px' }} gutter={12}>
                        <Col>
                          <DownloadOutlined
                            style={{ cursor: 'pointer' }}
                            onClick={() => window.open(documentFile.urlLink)}
                          />
                        </Col>
                        {!loading && (
                          <Col>
                            <DeleteOutlined
                              style={{ cursor: 'pointer' }}
                              onClick={onDeleteFile}
                            />
                          </Col>
                        )}
                        <Col>
                          {documentFile.name || documentFile.originalFileName}
                        </Col>
                      </Row>
                    )}
                  </div>

                  <Form.Item
                    hidden
                    style={{ width: '100%' }}
                    name="amoun_sum_propis"
                    initialValue={getWordedNumber(application.financeTotalMajor)}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    style={{ width: '100%' }}
                    hidden
                    name="money_sum_propis"
                    initialValue={getWordedNumber(hospitalTotal.major || 0)}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    style={{ width: '100%' }}
                    hidden
                    name="people_total_propis"
                    initialValue={getWordedNumber(application.peopleTotalMajor)}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    style={{ width: '100%' }}
                    name="step1_sum_propis"
                    hidden
                    initialValue={getWordedNumber(getStepSum('2023').major)}
                  >
                    <Input />
                  </Form.Item>
                  {(application.projectTerm === '2' ||
                    application.projectTerm === '3') && (
                      <Form.Item
                        hidden
                        style={{ width: '100%' }}
                        name="step2_sum_propis"
                        initialValue={getWordedNumber(getStepSum('2024').major)}
                      >
                        <Input />
                      </Form.Item>
                    )}
                  {application.projectTerm === '3' && (
                    <Form.Item
                      hidden
                      style={{ width: '100%' }}
                      name="step3_sum_propis"
                      initialValue={getWordedNumber(getStepSum('2025').major)}
                    >
                      <Input />
                    </Form.Item>
                  )}
                </div>

                <hr style={{ margin: '40px 0px' }} />

                <div className="common-subTitle" style={{ fontSize: '20px' }}>
                  <b>Основания для заключения Соглашения с Грантополучателем</b>
                </div>

                <div className="common-table-wrapper">
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderBottom: '1px solid #d9d9d9' }}
                    >
                      Протокол СГВ № (указать)
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="protokolNo"
                      initialValue={agreementData?.protokolNo || '1/2025'}
                    >
                      <Input />
                    </Form.Item>
                  </div>

                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderBottom: '1px solid #d9d9d9' }}
                    >
                      Протокол СГВ от (ДД.ММ.ГГГГ);
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="protokol_date"
                      initialValue={parseDate(
                        agreementData?.protokol_date,
                        '31 января 2025 года'
                      )}
                    >
                      <DatePicker format="DD MMMM YYYY года" />
                    </Form.Item>
                  </div>

                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderBottom: '1px solid #d9d9d9' }}
                    >
                      Приказ Медтеха № (указать);
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="prikaz_no"
                      initialValue={agreementData?.prikaz_no || '03/2025-ОД'}
                    >
                      <Input />
                    </Form.Item>
                  </div>

                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderBottom: '1px solid #d9d9d9' }}
                    >
                      От (ДД.ММ.ГГГГ);
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="prikaz_date"
                      initialValue={parseDate(
                        agreementData?.prikaz_date,
                        '31 января 2025 года'
                      )}
                    >
                      <DatePicker format="DD MMMM YYYY года" />
                    </Form.Item>
                  </div>
                </div>

                <hr style={{ margin: '40px 0px' }} />

                <div className="common-subTitle" style={{ fontSize: '20px' }}>
                  <b>Банковские реквизиты Грантополучателя</b>
                </div>
                <div
                  className="common-subTitle"
                  style={{ fontSize: '16px', fontStyle: 'italic' }}
                >
                  <b>
                    Укажите в соответствии с учетной карточкой (реквизитов)
                    организации
                  </b>
                </div>

                <div className="common-table-wrapper">
                  <div className="common-table-row">
                    <div className="common-table-row-cell">ОГРН</div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="ogrn"
                      initialValue={agreementData?.ogrn || ''}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="common-table-row">
                    <div className="common-table-row-cell">ИНН</div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="inn"
                      initialValue={agreementData?.inn || ''}
                    >
                      <Input />
                    </Form.Item>
                  </div>

                  <div className="common-table-row">
                    <div className="common-table-row-cell">КПП</div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="kpp"
                      initialValue={agreementData?.kpp || ''}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderBottom: '1px solid #d9d9d9' }}
                    >
                      Юридический адрес:{' '}
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="ur_address"
                      initialValue={agreementData?.ur_address || ''}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderBottom: '1px solid #d9d9d9' }}
                    >
                      Получатель:
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="poluchatel"
                      initialValue={agreementData?.poluchatel || ''}
                    >
                      <Input />
                    </Form.Item>
                  </div>

                  <>
                    <div className="common-table-row">
                      <div
                        className="common-table-row-cell"
                        style={{ borderBottom: '1px solid #d9d9d9' }}
                      >
                        Наименование банка:
                      </div>
                      <Form.Item
                        style={{ width: '100%' }}
                        name="bank"
                        initialValue={agreementData?.bank || ''}
                      >
                        <Input />
                      </Form.Item>
                    </div>

                    <div className="common-table-row">
                      <div
                        className="common-table-row-cell"
                        style={{ borderBottom: '1px solid #d9d9d9' }}
                      >
                        Р/с:{' '}
                      </div>
                      <Form.Item
                        style={{ width: '100%' }}
                        name="rs"
                        initialValue={agreementData?.rs || ''}
                      >
                        <Input />
                      </Form.Item>
                    </div>
                    <div className="common-table-row">
                      <div
                        className="common-table-row-cell"
                        style={{ borderBottom: '1px solid #d9d9d9' }}
                      >
                        К/с:{' '}
                      </div>
                      <Form.Item
                        style={{ width: '100%' }}
                        name="ks"
                        initialValue={agreementData?.ks || ''}
                      >
                        <Input />
                      </Form.Item>
                    </div>
                    <div className="common-table-row">
                      <div
                        className="common-table-row-cell"
                        style={{ borderBottom: '1px solid #d9d9d9' }}
                      >
                        БИК:{' '}
                      </div>
                      <Form.Item
                        style={{ width: '100%' }}
                        name="bik"
                        initialValue={agreementData?.bik || ''}
                      >
                        <Input />
                      </Form.Item>
                    </div>
                    <div className="common-table-row">
                      <div
                        className="common-table-row-cell"
                        style={{ borderBottom: '1px solid #d9d9d9' }}
                      >
                        ОКТМО:{' '}
                      </div>
                      <Form.Item
                        style={{ width: '100%' }}
                        name="oktmo"
                        initialValue={agreementData?.oktmo || ''}
                      >
                        <Input />
                      </Form.Item>
                    </div>
                  </>

                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderBottom: '1px solid #d9d9d9' }}
                    >
                      Дополнительная информация:{' '}
                      <div
                        style={{
                          marginTop: '16px',
                          fontStyle: 'italic',
                          fontSize: 12,
                        }}
                      >
                        При необходимости укажите электронную почту, факс или
                        телефон
                      </div>
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="other_info_requisits"
                      initialValue={agreementData?.other_info_requisits || ''}
                    >
                      <TextArea placeholder="Введите текст" autoSize />
                    </Form.Item>
                  </div>
                </div>

                <hr style={{ margin: '40px 0px' }} />

                <div className="common-subTitle" style={{ marginTop: '40px' }}>
                  <b>План-график Грантополучателя</b>
                </div>
                {/* <span className="common-field-hint">Проект может выполняться от 1 года до 3-х лет. Каждый календарный год выполнения проекта соответствует 1 этапу (каждый этап длится до 12 месяцев).</span> */}
                {/* <br /> */}
                {/* <span className="common-field-hint">Перечень разрабатываемых документов по каждому этапу формирует заявитель, при этом в отчетную документацию должны быть обязательно включены аннотированный и финансовый отчеты. Аннотированный отчет предполагает краткое описание полученных научных результатов за соответствующий период и формируется по результатам завершения Проекта.</span> */}
                {/* <br /> */}
                {/* <span className="common-field-hint">Сведения, указанные в графе «Ожидаемый результат» должны содержать в себе перечень результатов, которые будут получены в соответствии с содержанием выполняемых работ и мероприятий по каждому конкретному этапу. Ожидаемый результат также должен содержать количественные показатели выполняемых работ и мероприятий (например: количество проб/объектов для проведения исследования и т.п.). Пример: Проведены масс-спектрометрические измерения 1000 образцов плазмы крови. Подготовлена база данных (в формате .xls), содержащая результаты измерений 1000 образцов плазмы крови.</span> */}
                <div
                  className="common-table-wrapper"
                  style={{ marginTop: '10px' }}
                >
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{
                        width: '4%',
                        textAlign: 'center',
                        fontWeight: 'bold',
                      }}
                    >
                      № п/п
                    </div>
                    <div
                      className="common-table-row-cell"
                      style={{
                        width: '16%',
                        textAlign: 'center',
                        fontWeight: 'bold',
                      }}
                    >
                      Наименование этапа
                    </div>
                    <div
                      className="common-table-row-cell"
                      style={{
                        width: '16%',
                        textAlign: 'center',
                        fontWeight: 'bold',
                      }}
                    >
                      Содержание выполняемых работ и мероприятий
                    </div>
                    <div
                      className="common-table-row-cell"
                      style={{
                        width: '16%',
                        textAlign: 'center',
                        fontWeight: 'bold',
                      }}
                    >
                      Дата начала и окончания выполнения работ в рамках этапа
                    </div>
                    <div
                      className="common-table-row-cell"
                      style={{
                        width: '16%',
                        textAlign: 'center',
                        fontWeight: 'bold',
                      }}
                    >
                      Ожидаемый результат
                    </div>
                    <div
                      className="common-table-row-cell"
                      style={{
                        width: '16%',
                        textAlign: 'center',
                        fontWeight: 'bold',
                      }}
                    >
                      Перечень разрабатываемых документов
                    </div>
                    <div
                      className="common-table-row-cell"
                      style={{
                        width: '16%',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        borderRight: '1px solid #d9d9d9',
                      }}
                    >
                      Комментарий
                    </div>
                  </div>

                  {['1', '2', '3'].includes(application.projectTerm) && (
                    <PlanRow
                      index={1}
                      application={application}
                      disabled={disabled}
                      total={Number(application.projectTerm)}
                      agreementData={agreementData}
                      formRef={formRef}
                    />
                  )}
                  {['2', '3'].includes(application.projectTerm) && (
                    <PlanRow
                      index={2}
                      application={application}
                      disabled={disabled}
                      total={Number(application.projectTerm)}
                      agreementData={agreementData}
                      formRef={formRef}
                    />
                  )}
                  {['3'].includes(application.projectTerm) && (
                    <PlanRow
                      index={3}
                      application={application}
                      disabled={disabled}
                      total={Number(application.projectTerm)}
                      agreementData={agreementData}
                      formRef={formRef}
                    />
                  )}
                </div>

                <hr style={{ margin: '40px 0px' }} />

                <div className="common-subTitle" style={{ fontSize: '20px' }}>
                  <b>
                    Техническое задание Грантополучателя на выполнение работ в
                    рамках проекта
                  </b>
                </div>

                <div className="common-table-wrapper">
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9' }}
                    >
                      Цель, которая должна быть достигнута по завершении
                      реализации Проекта
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="tz_total_target"
                      initialValue={agreementData?.tz_total_target || ''}
                    >
                      <TextArea autoSize />
                    </Form.Item>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="tz_total_target_comment"
                      initialValue={agreementData?.tz_total_target_comment || ''}
                    >
                      <TextArea
                        placeholder="Комментарий администратора"
                        disabled={getUserRole() !== 'bigAdmin'}
                        style={{ color: 'red' }}
                        autoSize
                      />
                    </Form.Item>
                  </div>

                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9' }}
                    >
                      Перечень задач и работ, подлежащих выполнению в рамках
                      реализации Проекта
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="tz_tasks_list"
                      initialValue={agreementData?.tz_tasks_list || ''}
                    >
                      <TextArea autoSize />
                    </Form.Item>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="tz_tasks_list_comment"
                      initialValue={agreementData?.tz_tasks_list_comment || ''}
                    >
                      <TextArea
                        placeholder="Комментарий администратора"
                        disabled={getUserRole() !== 'bigAdmin'}
                        style={{ color: 'red' }}
                        autoSize
                      />
                    </Form.Item>
                  </div>

                  {/* <div className="common-table-row">
                  <div
                    className="common-table-row-cell"
                    style={{ borderRight: '1px solid #d9d9d9' }}
                  >
                    Подробное описание работ, подлежащих выполнению, в рамках
                    реализации Проекта
                  </div>
                  <Form.Item
                    style={{ width: '100%' }}
                    name="tz_total_works"
                    initialValue={agreementData?.tz_total_works || ''}
                  >
                    <TextArea autoSize />
                  </Form.Item>
                  <Form.Item
                    style={{ width: '100%' }}
                    name="tz_total_works_comment"
                    initialValue={agreementData?.tz_total_works_comment || ''}
                  >
                    <TextArea placeholder='Комментарий администратора' disabled={getUserRole() !== 'bigAdmin'} style={{ color: 'red' }} autoSize />
                  </Form.Item>
                </div> */}
                  {/* <div className="common-table-row">
                  <div
                    className="common-table-row-cell"
                    style={{ borderRight: '1px solid #d9d9d9' }}
                  >
                    Требования (в том числе технические) к работам, выполняемым
                    в рамках реализации Проекта
                  </div>
                  <Form.Item
                    style={{ width: '100%' }}
                    name="tz_total_trebovania_1"
                    initialValue={agreementData?.tz_total_trebovania_1 || ''}
                  >
                    <TextArea autoSize />
                  </Form.Item>
                  <Form.Item
                    style={{ width: '100%' }}
                    name="tz_total_trebovania_1_comment"
                    initialValue={agreementData?.tz_total_trebovania_1_comment || ''}
                  >
                    <TextArea placeholder='Комментарий администратора' disabled={getUserRole() !== 'bigAdmin'} style={{ color: 'red' }} autoSize />
                  </Form.Item>
                </div> */}
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9' }}
                    >
                      Перечень результатов работ, которые должны быть получены по
                      завершении реализации Проекта
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="tz_total_perechen_1"
                      initialValue={agreementData?.tz_total_perechen_1 || ''}
                    >
                      <TextArea autoSize />
                    </Form.Item>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="tz_total_perechen_1_comment"
                      initialValue={
                        agreementData?.tz_total_perechen_1_comment || ''
                      }
                    >
                      <TextArea
                        placeholder="Комментарий администратора"
                        disabled={getUserRole() !== 'bigAdmin'}
                        style={{ color: 'red' }}
                        autoSize
                      />
                    </Form.Item>
                  </div>
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9' }}
                    >
                      Требования к результатам работ по Проекту
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="tz_total_trebovania_2"
                      initialValue={agreementData?.tz_total_trebovania_2 || ''}
                    >
                      <TextArea autoSize />
                    </Form.Item>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="tz_total_trebovania_2_comment"
                      initialValue={
                        agreementData?.tz_total_trebovania_2_comment || ''
                      }
                    >
                      <TextArea
                        placeholder="Комментарий администратора"
                        disabled={getUserRole() !== 'bigAdmin'}
                        style={{ color: 'red' }}
                        autoSize
                      />
                    </Form.Item>
                  </div>
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9' }}
                    >
                      Перечень разрабатываемых документов
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="tz_total_perechen_2"
                      initialValue={agreementData?.tz_total_perechen_2 || ''}
                    >
                      <TextArea autoSize />
                    </Form.Item>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="tz_total_perechen_2_comment"
                      initialValue={
                        agreementData?.tz_total_perechen_2_comment || ''
                      }
                    >
                      <TextArea
                        placeholder="Комментарий администратора"
                        disabled={getUserRole() !== 'bigAdmin'}
                        style={{ color: 'red' }}
                        autoSize
                      />
                    </Form.Item>
                  </div>
                  {/* <div className="common-table-row">
                  <div
                    className="common-table-row-cell"
                    style={{
                      borderRight: '1px solid #d9d9d9',
                      borderBottom: '1px solid #d9d9d9',
                    }}
                  >
                    Требования к разрабатываемой документации
                    {' '}
                  </div>
                  <Form.Item
                    style={{ width: '100%' }}
                    name="tz_total_trebovania_3"
                    initialValue={agreementData?.tz_total_trebovania_3 || ''}
                  >
                    <TextArea autoSize />
                  </Form.Item>
                  <Form.Item
                    style={{ width: '100%' }}
                    name="tz_total_trebovania_3_comment"
                    initialValue={agreementData?.tz_total_trebovania_3_comment || ''}
                  >
                    <TextArea placeholder='Комментарий администратора' disabled={getUserRole() !== 'bigAdmin'} style={{ color: 'red' }} autoSize />
                  </Form.Item>
                </div> */}
                </div>

                <hr style={{ margin: '40px 0px' }} />

                <div className="common-subTitle" style={{ fontSize: '20px' }}>
                  <b>Планируемые показатели эффективности проекта</b>
                </div>

                <div className="common-table-wrapper">
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9', width: '60px' }}
                    >
                      1.
                    </div>
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9' }}
                    >
                      Общее количество публикаций о проекте по завершении его
                      реализации в журналах, входящих в «белый список» научных
                      журналов
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="pep_1"
                      initialValue={
                        agreementData?.pep_1 ||
                        application?.numberOfPublicationsTotal ||
                        ''
                      }
                    >
                      <Input
                        value={
                          agreementData?.pep_1 ||
                          application?.numberOfPublicationsTotal
                        }
                      />
                    </Form.Item>
                  </div>
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9', width: '60px' }}
                    >
                      1.1.
                    </div>
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9' }}
                    >
                      Количество публикаций о проекте по завершении его реализации
                      в журналах, входящих в "белый список" 1 и 2 уровня
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="numberOfPublicationsLevelVAC1_2"
                      initialValue={
                        agreementData?.numberOfPublicationsLevelVAC1_2
                      }
                    >
                      <Input
                        value={agreementData?.numberOfPublicationsLevelVAC1_2}
                      />
                    </Form.Item>
                  </div>
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9', width: '60px' }}
                    >
                      2.
                    </div>
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9' }}
                    >
                      Количество результатов интеллектуальной деятельности,
                      планируемых по завершении реализации проекта
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      initialValue={application?.numberOfRID || ''}
                    >
                      <Input value={application?.numberOfRID} disabled />
                    </Form.Item>
                  </div>
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9', width: '60px' }}
                    >
                      3.
                    </div>
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9' }}
                    >
                      Количество мероприятий по демонстрации результатов
                      реализации проекта
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="ppep_3"
                      initialValue={
                        parseInt(agreementData?.ppep_3 || '0', 10) ||
                        parseInt(application?.numberOfEvents || '0', 10) +
                        parseInt(application?.numberOfPerformance || '0', 10) ||
                        ''
                      }
                    >
                      <Input disabled />
                    </Form.Item>
                  </div>
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9', width: '60px' }}
                    >
                      3.1.
                    </div>
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9' }}
                    >
                      Всероссийского и регионального уровней
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      name="ppep_3_1"
                      initialValue={
                        agreementData?.ppep_3_1 ||
                        application?.numberOfEvents ||
                        ''
                      }
                    >
                      <Input onChange={handlePepChange} />
                    </Form.Item>
                  </div>
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9', width: '60px' }}
                    >
                      3.2.
                    </div>
                    <div
                      className="common-table-row-cell"
                      style={{ borderRight: '1px solid #d9d9d9' }}
                    >
                      Международного уровня
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      initialValue={application?.numberOfPerformance || ''}
                    >
                      <Input value={application?.numberOfPerformance} disabled />
                    </Form.Item>
                  </div>
                  <div className="common-table-row">
                    <div
                      className="common-table-row-cell"
                      style={{ borderBottom: '1px solid #d9d9d9', width: '60px' }}
                    >
                      4.
                    </div>
                    <div
                      className="common-table-row-cell"
                      style={{ borderBottom: '1px solid #d9d9d9' }}
                    >
                      Общее количество пациентов, предусмотренных для реализации
                      проекта
                    </div>
                    <Form.Item
                      style={{ width: '100%' }}
                      initialValue={application?.numberOfPatienceTotal || ''}
                    >
                      <Input
                        value={application?.numberOfPatienceTotal}
                        disabled
                      />
                    </Form.Item>
                  </div>
                </div>

                {application.applications2PersonsTabPeople_ids.length > 0 && (
                  <>
                    <hr style={{ margin: '40px 0px' }} />

                    <div className="common-subTitle" style={{ fontSize: '20px' }}>
                      <b>Меры поддержки</b>
                    </div>

                    {application.applications2PersonsTabPeople_ids.filter((el) => !el.isDeleted).map(
                      (item, index) => (
                        <ProjectInfoPerson
                          formRef={formRef}
                          item={item}
                          key={item.fullName}
                          index={index}
                          application={application}
                          onCreateCoexecutorProject={
                            handleCreateCoexecutorProject
                          }
                        />
                      )
                    )}
                  </>
                )}
              </div>

              <Button
                type="primary"
                onClick={onSaveForm}
                style={{ marginTop: '15px' }}
              >
                Сохранить
              </Button>
            </Card>
          </Col>
          <Col span={8} style={{ marginTop: '22px' }} >
            <Anchor offsetTop={20}>
                <Col style={{marginBottom: '10px', padding: 0}}>

                    <Button
                      type="primary"
                      onClick={onSaveForm}
                      style={{ marginRight: '15px', marginBottom: '8px' }}
                    >
                      Сохранить
                    </Button>
                    {getUserRole() === 'bigAdmin' && (
                      <Button
                        type="primary"
                        onClick={generateAgreement}
                        style={{ marginRight: '15px', marginBottom: '8px' }}
                      >
                        Сформировать соглашение
                      </Button>
                    )}
                    {application?.id &&
                      getUserRole() === 'bigAdmin' &&
                      application?.status === 'Поддержана' && (
                        <Popconfirm
                          okText="Вернуть в заявку"
                          cancelText="Отмена"
                          onConfirm={handleCancelProject}
                          title="Вы уверены, что хотите вернуть в заявку?"
                        >
                          <Button
                            type="danger"
                            style={{ marginRight: '10px', marginBottom: '8px' }}
                            disabled={loading}
                          >
                            Вернуть в заявку
                          </Button>
                        </Popconfirm>
                      )}
                </Col>
                <DocumentsList applicationProp={application} getMethod={getApplications2ById} postMethod={editApplications2} />
            </Anchor>
          </Col>
        </Row>
      )}
    </Form>
  );
}

ProjectInfo.propTypes = {
  applicationProp: PropTypes.shape().isRequired,
  onRedirectToList: PropTypes.func.isRequired,
  // updateOriginalObject: PropTypes.func.isRequired,
};

export default ProjectInfo;
